import { DragDropButton } from '@/components/gantt/dragDrop/DragDropButton';
import { ItemTypes } from '@/components/gantt/dragDrop/types';
import { FC } from 'react';
import strings from '../roster.translations';
import { itemTypeToColor } from '@/helpers/dailyHelper';
import { BsCupFill } from 'react-icons/bs';
import { useGetTaskIcon, useTasks } from '@/services/tasks/useTasks';

export const RosterTaskButtons: FC = () => {
  const tasks = useTasks();
  const getTaskIcon = useGetTaskIcon();

  return (
    <div className="space-y-2">
      <div className="font-semibold">{strings.drawer.tasks.direction}</div>
      <div className="flex gap-3 flex-wrap">
        <DragDropButton
          name={strings.drawer.tasks.break}
          Icon={BsCupFill}
          color={itemTypeToColor(ItemTypes.BREAK)}
          textColor="white"
          item={{ type: ItemTypes.BREAK }}
        />
        {tasks.map(task => (
          <DragDropButton
            name={task.displayName}
            Icon={getTaskIcon(task.id)}
            color={task.color}
            textColor={task.textColor}
            item={{ type: ItemTypes.TASK, context: task.id }}
          />
        ))}
      </div>
    </div>
  );
};
